module.exports = __webpack_public_path__ + "img/arrow_down.8c7c69a9.svg";